export default {
  url: process.env.VSF_OMNIBUS_API_URL,
  widgetUrl: process.env.VSF_OMNIBUS_WIDGET_URL,
  key: process.env.VSF_OMNIBUS_API_KEY,
  color: '#D12727',
  font: 'neue-haas-unica',
  type: 'Line',
};
